import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { Municipio } from '../api/dto/municipio';

@Injectable({
    providedIn: 'root'
})
export class MunicipioService{

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'municipios/uf/';
    
    listarMuniciosPorUf(codigoUf?: number): Observable<Municipio[]>  {
        return this.http.get<Municipio[]>(this.url + codigoUf);
    }

    
    
}